import styled from "styled-components";
// import { Link } from "@smartups-sl/react-basic-components";

export const AddItemContainerStyled = styled.div`
  text-align: right;
`;

export const LinkAddItemStyled = styled.a`
  font-size: 1.5rem;
`;

export const FloatAddItem = styled.a`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  z-index: 100;
  background-color: ${({ theme, $variant }) =>
    theme ? theme.buttons[$variant].backgroundColor : "#000"} !important;
  color: ${({ theme, $variant }) =>
    theme ? theme.buttons[$variant].color : "#fff"} !important;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #5d5d5d;
  border: 0px;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    text-decoration: none !important;
    color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant].colorHover : "#fff"} !important;
    background-color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant].backgroundColorHover : "#000"} !important;
    border-color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant].borderColorHover : "#000"} !important;
  }
`;

export const EndMessage = styled.div`
  margin-bottom: 100px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonMore = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: ${({ theme, $variant }) =>
    theme ? theme.buttons[$variant].backgroundColor : "#000"} !important;
  color: ${({ theme, $variant }) =>
    theme ? theme.buttons[$variant].color : "#fff"} !important;

  &:hover {
    text-decoration: none !important;
    color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant].colorHover : "#fff"} !important;
    background-color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant].backgroundColorHover : "#000"} !important;
    border-color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant].borderColorHover : "#000"} !important;
  }
`;

export const ContainerButton = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonTop = styled.button`
  font-weight: 400;
  background: transparent !important;
  border: 0px;
  color: ${({ theme, $variant }) =>
    theme ? theme.buttons[$variant]?.color : "#fff"} !important;

  &:hover {
    text-decoration: none !important;
    color: ${({ theme, $variant }) =>
      theme ? theme.buttons[$variant]?.colorHover : "#fff"} !important;
  }
`;

export const IconButtonTop = styled.i`
  margin-left: 0.6rem;
`;

export const FloatCustomAction = styled.button`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  z-index: 100;
  background-color: #000;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #5d5d5d;
  border: 0px;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    text-decoration: none;
    color: #fff;
    background-color: #000;
    border-color: #000;
  }
`;

export const EmptyState = styled.div`
  padding: 60px 25px;
  text-align: center;
  color: #999;
`;

export const EmptyIcon = styled.div`
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.5;
`;

export const EmptyMessage = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
`;
